import { createStore } from 'vuex'
import { getField, updateField } from "vuex-map-fields";
import _ from 'lodash';

import clientConfig from '../config/client';
import { defaultConfiguration } from 'super-engine';
// -----------------------------------------------------


const state = {
  debugMode: false,
  lastUpdated: clientConfig.lastUpdated,
  activeTab: 1,
  lastActiveTab: 1,
  isResultTabActive: true,

  superEngineConfig: _.defaultsDeep(require('/src/config/superEngineConfig'), defaultConfiguration),

  data: clientConfig.params,
  taxedFund: clientConfig.defaults.taxedFund ?? false,
  memberType: clientConfig.defaults.memberType,
  age: clientConfig.defaults.age,
  salary: clientConfig.defaults.salary,
  salaryFrequency: clientConfig.defaults.salaryFrequency,
  taxableIncome: clientConfig.defaults.taxableIncome,
  // spareCashflow: clientConfig.defaults.spareCashflow,
  superannuationBalance: clientConfig.defaults.superannuationBalance,
  employerContributionRate: clientConfig.defaults.employerContributionRate,

  contributionsAfterTax: clientConfig.defaults.contributionsAfterTax,
  contributionsBeforeTax: clientConfig.defaults.contributionsBeforeTax,
  contributionsAfterTaxFrequency: clientConfig.defaults.contributionsAfterTaxFrequency,
  contributionsBeforeTaxFrequency: clientConfig.defaults.contributionsAfterTaxFrequency,

  spareCashAmount: clientConfig.defaults.spareCashAmount,
  spareCashAmountFrequency: clientConfig.defaults.spareCashAmountFrequency,
  // currentVoluntaryConcessionalContributions: clientConfig.defaults.currentVoluntaryConcessionalContributions,
  // currentVoluntaryNonConcessionalContributions: clientConfig.defaults.currentVoluntaryNonConcessionalContributions,

  // currentVoluntaryConcessionalContributionsFrequency: null,
  // currentVoluntaryNonConcessionalContributionsFrequency: null,

};

// -----------------------------------------------------

const frequencyPerYear = frequency => {
  switch(frequency) {
    case 'year': return state.data.frequency.year;
    case 'month': return state.data.frequency.month;
    case 'fortnight': return state.data.frequency.fortnight;
    case 'week': return state.data.frequency.week;
    default: return state.data.frequency.year;
  }
};

// -----------------------------------------------------

const mutations = {
  setActiveTab(state, value) {
    if (state.activeTab !== 6) {
      state.lastActiveTab = state.activeTab;
    }
    state.activeTab = value;
  },

  setIsResultTabActive(state, value) {
    state.isResultTabActive = value;
  },

  setIsEditingAssumptions(state, value) {
    state.isEditingAssumptions = value;
  },

  updateAge(state, value) {
    state.age = value;
  },

  updateSalary(state, value) {
    state.salary = value;
  },

  updateMemberType(state, value) {
    state.memberType = value;
  },

  updateTaxedFund(state, value) {
    state.taxedFund = value;
  },

  // updateTaxableIncome(state, value) {
  //   state.taxableIncome = value;
  // },

  // updatespareCashflow(state, value) {
  //   state.spareCashflow = value;
  // },

  updateSuperannuationBalance(state, value) {
    state.superannuationBalance = value;
  },

  updateEmployerContributionRate(state, value) {
    state.employerContributionRate = value;
  },

  updateContributionsAfterTax(state, value) {
    state.contributionsAfterTax = value;
  },

  updateContributionsBeforeTax(state, value) {
    state.contributionsBeforeTax = value;
    console.log(value)
  },

  updateContributionsAfterTaxFrequency(state, value) {
    state.contributionsAfterTaxFrequency = value;
  },

  updateContributionsBeforeTaxFrequency(state, value) {
    state.contributionsBeforeTaxFrequency = value;
  },

  updateCurrentVoluntaryConcessionalContributions(state, value) {
    state.currentVoluntaryConcessionalContributions = value;
  },

  updateCurrentVoluntaryNonConcessionalContributions(state, value) {
    state.currentVoluntaryNonConcessionalContributions = value;
  },

  updateCurrentVoluntaryConcessionalContributionsFrequency(state, value) {
    state.currentVoluntaryConcessionalContributionsFrequency = value;
  },

  updateCurrentVoluntaryNonConcessionalContributionsFrequency(state, value) {
    state.currentVoluntaryNonConcessionalContributionsFrequency = value;
  },

  updateSalaryFrequency(state, value) {
    state.salaryFrequency = value;
  },

  updateSpareCashAmount(state, value) {
    state.spareCashAmount = value;
  },

  updateSpareCashAmountFrequency(state, value) {
    state.spareCashAmountFrequency = value;
  },

  updateEmployerContributionRateForEngine(state) {
    state.superEngineConfig.EmployerContributionRate = state.employerContributionRate / 100;
    state.superEngineConfig.EmployerContributionRate_2 = state.employerContributionRate / 100;
  },

  updateAnnualBeforeTaxSalaryForEngine(state) {
    state.superEngineConfig.Salary = state.salary / frequencyPerYear(state.salaryFrequency);
  },

  // These currently don't take into account spareCashAmount or spareCashAmountFrequency

  updateAnnualContributionsAfterTaxForEngine: (state) => {
    state.superEngineConfig.PostTaxMemberContributions = state.contributionsAfterTax / frequencyPerYear(state.contributionsAfterTaxFrequency);
  },

  updateAnnualContributionsBeforeTaxForEngine: (state) => {
    state.superEngineConfig.PreTaxMemberContributions = state.contributionsBeforeTax / frequencyPerYear(state.contributionsBeforeTaxFrequency);
  },

  updateField
};

// -----------------------------------------------------

const getters = {
  debugMode: state => {
    return state.debugMode;
  },

  lastUpdated: state => {
    return state.lastUpdated;
  },

  updateTriggered: state => {
    return state;
  },

  activeTab: state => {
    return state.activeTab;
  },

  isResultTabActive: state => {
    return state.isResultTabActive;
  },

  lastActiveTab: state => {
    return state.lastActiveTab;
  },

  superEngineConfig: state => {
    return state.superEngineConfig;
  },

  data: state => {
    return state.data;
  },

  salaryPeriod: (state) => {
    return frequencyPerYear(state.salaryFrequency);
  },

  afterTaxTimePeriod: (state) => {
    return frequencyPerYear(state.contributionsAfterTaxFrequency);
  },

  beforeTaxTimePeriod: (state) => {
    return frequencyPerYear(state.contributionsBeforeTaxFrequency);
  },

  spareCashAmountPeriod: (state) => {
    return frequencyPerYear(state.spareCashAmountFrequency);
  },

  annualSalary: (state, getters) => {
    return state.salary / getters.salaryPeriod;
  },

  annualContributionsAfterTax: (state, getters) => {
    return state.contributionsAfterTax / getters.afterTaxTimePeriod;
  },

  annualContributionsBeforeTax: (state, getters) => {
    return state.contributionsBeforeTax / getters.beforeTaxTimePeriod;
  },

  annualSpareCashAmount: (state, getters) => {
    return state.spareCashAmount / getters.spareCashAmountPeriod;
  },

  getField
};

export default createStore({
  state,
  mutations,
  getters
});